import React from 'react';
import bgImage from '../assets/Blackwomen/handsoncomputer2.jpg'; // ✅ Local image import

const BrandShine = () => {
  return (
    <section className="relative w-full h-[650px] md:h-[700px] bg-center bg-cover bg-no-repeat" style={{
      backgroundImage: `url(${bgImage})`
    }}>
      {/* Top Link */}
      <div className="absolute top-0 left-0 w-full flex justify-center pt-6 z-20">
        <div className="flex gap-4 text-sm md:text-base items-center bg-white bg-opacity-90 px-4 py-2 shadow-md">
          <a href='/clientwork' className="text-gray-700 tracking-wide">&laquo; Our Work</a>
          <span className="text-teal-600 font-handwritten text-xl">browse more</span>
        </div>
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>

      {/* Centered Content */}
      <div className="relative z-10 flex items-center justify-center h-full px-6">
        <div className="bg-white bg-opacity-90 backdrop-blur-sm text-center px-6 py-10 max-w-xl shadow-lg">
          <h1 className="text-2xl sm:text-3xl md:text-4xl  text-gray-900 leading-snug">
            Your brand’s online home<br />
            deserves to <span className="italic">shine</span>. Ready for<br />
            your website <span className="italic">glow-up</span>?
          </h1>
          <a href='/clientwork'>
          <button className="mt-6 px-6 py-3 bg-[#c6884a] text-white font-semibold text-sm uppercase tracking-wide hover:bg-[#b27432] transition">
            Let’s Get Started
          </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BrandShine;
